var spacing = function spacing() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var spacingFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (typeof value === 'string') {
    return value;
  }

  return "".concat(value * spacingFactor, "px");
};

export var makeSpacing = function makeSpacing(theme) {
  if (typeof theme.spacing === 'function') {
    return theme.spacing;
  }

  var spacingFactor = theme.spacing;
  return function (value) {
    return spacing(value, spacingFactor);
  };
};